export const LOAD_QVCT_SURVEYS = 'LOAD_QVCT_SURVEYS'
export const LOAD_QVCT_SURVEY_STATS = 'LOAD_QVCT_SURVEY_STATS'
export const LOAD_QVCT_SURVEY_OPINION = 'LOAD_QVCT_SURVEY_OPINION'
export const LOAD_QVCT_SURVEY = 'LOAD_QVCT_SURVEY'
export const LOAD_QVCT_SURVEY_FROM_FOR_RESPONSE = 'LOAD_QVCT_SURVEY_FROM_FOR_RESPONSE'
export const LOAD_QVCT_SURVEY_RESPONSES = 'LOAD_QVCT_SURVEY_RESPONSES'
export const ADD_QVCT_SURVEY = 'ADD_QVCT_SURVEY'
export const ADD_QVCT_SURVEY_QUESTION = 'ADD_QVCT_SURVEY_QUESTION'
export const REMOVE_QVCT_SURVEY_QUESTION = 'REMOVE_QVCT_SURVEY_QUESTION'
export const LOAD_QVCT_SURVEY_QUESTIONS = 'LOAD_QVCT_SURVEY_QUESTIONS'
export const LOAD_QVCT_SURVEY_QUESTION = 'LOAD_QVCT_SURVEY_QUESTION'
export const LOAD_QVCT_SURVEYS_CATEGORIES_WITHOUT_CHILDREN = 'LOAD_QVCT_SURVEYS_CATEGORIES_WITHOUT_CHILDREN'
export const LOAD_QVCT_SURVEYS_ROOT_CATEGORIES = 'LOAD_QVCT_SURVEYS_ROOT_CATEGORIES'
export const LOAD_QVCT_SURVEYS_ANSWER_TYPE = 'LOAD_QVCT_SURVEYS_ANSWER_TYPE'
export const LOAD_QVCT_SURVEY_STATUS = 'LOAD_QVCT_SURVEY_STATUS'